import { z } from 'zod';
import { eventRuleBaseSchema } from './event-rules.schema.ts';

const createEventRuleBaseSchema = eventRuleBaseSchema
  .pick({
    eventTitle: true,
    ruleType: true,

    deviceType: true,
    deviceId: true,
    deviceSN: true,

    conditions: true,

    eventTemplate: true,
    eventPreviewTemplate: true,

    cooldownPeriod: true,

    status: true,
  })
  .extend({
    plantId: z.string({ error: 'Plant name is required' }).min(1, 'Plant name is required'),

    forwardTo: z.array(z.string()).optional(),
  });

export const createEventRuleSchema = createEventRuleBaseSchema
  .refine(
    (data) => {
      if (data.ruleType === 'device') {
        return data.deviceType;
      }
      return true;
    },
    {
      message: 'Device type is required for device rules',
      path: ['deviceType'],
    }
  )
  .refine(
    (data) => {
      if (data.ruleType === 'device') {
        return data.deviceId;
      }
      return true;
    },
    {
      message: 'Device serial number is required for device rules',
      path: ['deviceId'],
    }
  );

export const basicInformationFormSchema = createEventRuleBaseSchema.pick({
  eventTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,
});

export const conditionsFormSchema = createEventRuleBaseSchema.pick({
  eventTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,
});

export const messageTemplateFormSchema = createEventRuleBaseSchema.pick({
  eventTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,

  eventTemplate: true,
  eventPreviewTemplate: true,
});

export const otherOptionsFormSchema = createEventRuleBaseSchema.pick({
  eventTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,

  eventTemplate: true,
  eventPreviewTemplate: true,

  cooldownPeriod: true,
  forwardTo: true,
});

export type EventRuleFormData = z.infer<typeof createEventRuleSchema>;
